import React, { act, useEffect } from 'react'
import withModal from '../../utils/hoc/withModal'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-stores/store'
import { FREE_SUBSCRIPTION_PLAN_ID } from '../../constants/constants'
import { analyticsLog } from '../../lib/analytics'
const OutOfCredits: React.FC<{onClose: () => void, isActive: boolean}> = ({onClose, isActive}) => {

    const activePlan = useSelector((state: RootState) => state.influencer.active_plan);

    useEffect(() => {
        if(isActive && activePlan){
            analyticsLog('credits_low', {
                plan: activePlan.plan?.name,
                source: 'campaign_apply'
            })
        }
    }, [isActive, activePlan])

  return (
     <React.Fragment>
            <div className="menu-title p-3">
                <h3 className="pop">
                    <span className="text-warning"><i className='fa fa-warning'></i></span>
                </h3>
                <button onClick={onClose} className="close-menu font-16"><i className="fa fa-times-circle"></i></button>
            </div>
            <div className="card rounded-4 shadow-none border-0">
                <div className="card-body d-flex flex-column py-1">
                    You ran out of credits!
                    <div className="d-flex align-items-center justify-content-between mt-3 gap-2">
                        <button className="btn btn-secondary btn-sm rounded-4 flex-grow-1" onClick={onClose}>Close</button>
                        <Link to={{pathname: activePlan?.plan?.id === FREE_SUBSCRIPTION_PLAN_ID ? "/subscription-plans" : "/subscription"}} className="btn btn-primary btn-sm rounded-4 flex-grow-1">Subscribe</Link>
                    </div>
                </div>
            </div>
        </React.Fragment>
  )
}

export default withModal(OutOfCredits)
